import { useMemo } from 'react';
import categoryData from '../../config/categoryData.json';

export const useCategoryContent = () => {
    return useMemo(() => categoryData, []);
};
